import React from 'react'
import FlexView from 'react-flexview/lib'
import { OptionalTag } from '../../Core/OptionalTag'
import { HullPopover } from '../../Core/Popover/HullPopover'
import { FormHelperText, GridList, Dialog, Popover, Grid } from '@material-ui/core'
import { DroneView } from '../../Core/Hull/DroneView'
import { EquipmentView } from '../../Core/Hull/EquipmentView'
import { ReactComponent as AddSvg } from '../../../assets/add.svg';
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import CircledPopUpFrame from '../../Core/CircledPopUpFrame'
import { ReactComponent as DroneCircle } from '../../../assets/drone_with_circle.svg';
import { ReactComponent as EquipmentCircle } from '../../../assets/equipment-with-circle.svg';
import { HullAddForm } from '../../Hull/HullAddForm'
import { isMobile } from 'react-device-detect'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import ViolationsService from '../../../services/ViolationsService'
import { COVERAGE_TYPES } from '../../../models/insurance-models/CoverageType'
import LocalizationService from '../../../services/LocalizationService'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';
import { isUK } from '../../../services/utils'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { BellFrame } from '../../Core/Frames/BellFrame'
import { useHistory } from 'react-router-dom'
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
import { SessionService } from '../../../services/SessionService'
import DiscountsService from '../../../services/DiscountsService'
import DataLayerService from '../../../services/DataLayerService'

export const CustomizeHullSection = () => {
    const insuracePurchaseContext = React.useContext(InsurancePurchaseContextStore)
    const offersContext = React.useContext(BuyingInsuranceContextStore)
    const [showAddHullPopup, setShowAddHullPopup] = React.useState(false)
    const [hullFormType, setHullFormType] = React.useState('drone')
    const [error, setError] = React.useState()
    const [editMode, setEditMode] = React.useState({
        edit: false,
        index: 0,
        selectedHull: {}
    })
    const isFirstRun = React.useRef(true);
    const [anchorElAddHull, setAnchorElAddHull] = React.useState(null);
    const addHullPopoverOpen = Boolean(anchorElAddHull)
    const history = useHistory()
    const [savings, setSavings] = React.useState(0)

    React.useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        setShowAddHullPopup(true)
    }, [editMode])

    React.useEffect(() => {
        let id1 = EventEmitterService.subscribe(EventKey.HULL_ITEM_CHANGED, () => {
            closeAddHull()
        })

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.HULL_ITEM_CHANGED, id1)
        }
    }, [])

    React.useEffect(() => {
        let violations = ViolationsService.checkHullViolations(insuracePurchaseContext.selectedOption, insuracePurchaseContext.drones, insuracePurchaseContext.equipment)
        if(violations.error) {
            setError(violations.msg)
        }
        else {
            setError('')
        }

        
        if(FirebaseService.getBoolean(FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_MONTHLY) && 
            insuracePurchaseContext.selectedOption.billingPeriod == InsuranceBillingPeriod.MONTH) {
                let annualOffer = offersContext.annualOffers.find(i => i.liabilityLimit == insuracePurchaseContext.selectedOption.liabilityLimit)
                let monthlyOffer = offersContext.monthlyOffers.find(i => i.liabilityLimit == insuracePurchaseContext.selectedOption.liabilityLimit)
                
                if(annualOffer && monthlyOffer) {
                    const savings = annualOffer.price < monthlyOffer.price * 12 ? (monthlyOffer.price * 12) - annualOffer.price : 0;
                    setSavings(savings);
                }
        }
    }, [insuracePurchaseContext.selectedOption, insuracePurchaseContext.drones, insuracePurchaseContext.equipment])

    const openEquipmentHull = () => {
        DataLayerService.pushToDataLayer({'event': 'equipment-pop-up-open'})
        setHullFormType('equipment');
        openAddHull()
    }

    const openDroneHull = () => {
        DataLayerService.pushToDataLayer({'event': 'drone-pop-up-open'})
        setHullFormType('drone');
        openAddHull()
    }

    const openAddHull = () => {
        setEditMode( prev => ({
            edit: false,
            selectedHull: {}
        }))
        setShowAddHullPopup(true)
    }

    const onDroneEdit = (hullItem, index) => {
        setHullFormType('drone')
        onHullEdit(hullItem, index)
    }
    
    const onEquipmentEdit = (hullItem, index) => {
        setHullFormType('equipment')
        onHullEdit(hullItem, index)
    }

    const onHullEdit = (hullItem, index) => {
        setEditMode( prev => ({
            edit: true,
            selectedHull: hullItem,
            index: index,
        }))
    }

    const onHullDelete = (item, index) => {
        insuracePurchaseContext.deleteItem(item, index)
    }

    const openHullPopver = (event) => {
        setAnchorElAddHull(event.currentTarget)
    }

    const closeHullPopver = () => {
        setAnchorElAddHull(null)
    }

    const closeAddHull = () => {
        setShowAddHullPopup(false)
    }

    const moveToAnnual = () => history.push('/insurance/annual')

    return (<React.Fragment>

        <FlexView vAlignContent={'center'} className="space-between margin-top-basic">
            <FlexView vAlignContent={'center'}>
                <div className="text-body bold black">{isMobile ? LocalizationService.STRINGS.hullSectionTitleMobile : LocalizationService.STRINGS.hullSectionTitle}</div>
                {!isUK() &&  <HullPopover /> }
            </FlexView>
            {!isUK() &&  <OptionalTag /> }
        </FlexView>


        {isMobile && <Grid container className="margin-top-small">
            <Grid item xs>
            {LocalizationService.STRINGS.hullSectionSubtitle.split("*").map(row =><div className="text-body gray margin-top-small">{row}</div>)}
                
            </Grid>
            <Grid item >
                <AddSvg onClick={openHullPopver} className="clickable add blue-svg-path" />
            </Grid>
        </Grid>}

        {!isMobile &&<> 
            {LocalizationService.STRINGS.hullSectionSubtitle.split("*").map(row =><div className="text-body gray margin-bottom-small margin-top-6">{row}</div>)}
            </>}
        {!!error && error}

        <GridList className="margin-top-small" spacing={2}>
            {insuracePurchaseContext.drones.map((drone, index) => <DroneView deleteable onDelete={() => onHullDelete(drone, index)} onEdit={() => onDroneEdit(drone, index)} key={index} drone={drone} />)}
            {insuracePurchaseContext.equipment.map((equip, index) => <EquipmentView deleteable onDelete={() => onHullDelete(equip, index)} onEdit={() => onEquipmentEdit(equip, index)} key={index} equip={equip} />)}
        </GridList>

        {!isMobile && 
            <FlexView>
                <FlexView className="clickable"  onClick={openDroneHull} vAlignContent={'center'}><AddSvg className="add blue-svg-path" /> <span className="text-body blue">Add drone</span></FlexView>
                {offersContext.coverageType == COVERAGE_TYPES.COMBINED && 
                    <FlexView className="margin-left-6 clickable" onClick={openEquipmentHull} vAlignContent={'center'}><AddSvg className="add blue-svg-path" /> <span className="text-body blue">Add equipment</span></FlexView> }
            </FlexView> }
        {insuracePurchaseContext.selectedOption.billingPeriod == InsuranceBillingPeriod.MONTH && savings > 0 &&
            <BellFrame>
                <div className="text-body gray"> <span className="bolder">Save {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{savings} a year</span> by switching to <span onClick={moveToAnnual} className="underline clickable">Skywatch annual</span> </div>
        </BellFrame>}

        <SkywatchDialog 
            open={showAddHullPopup} 
            maxWidth={'xs'}
            closeDialog={closeAddHull}
            circleHeader={hullFormType == 'drone' ? <DroneCircle /> : <EquipmentCircle />}
            closeTitle={'Hull Inventory'}>
            <HullAddForm openEquipmentFirst={hullFormType != 'drone'} editMode={editMode.edit} editIndex={editMode.index} defaultValues={editMode.selectedHull} equipment={insuracePurchaseContext.equipment}/>
        </SkywatchDialog>

        <Popover
            open={addHullPopoverOpen}
            anchorEl={anchorElAddHull}
            onClose={closeHullPopver}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'}}>
            <FlexView>
                <FlexView className="clickable"  onClick={() => {closeHullPopver(); openDroneHull(); }} vAlignContent={'center'}><AddSvg className="add blue-svg-path" /> <span className="text-body blue">Add drone</span></FlexView>
                {offersContext.coverageType == COVERAGE_TYPES.COMBINED && 
                    <FlexView className="margin-left-6 margin-right-6 clickable" onClick={() => {closeHullPopver(); openEquipmentHull();}} vAlignContent={'center'}><AddSvg className="add blue-svg-path" /> <span className="text-body blue">Add equipment</span></FlexView>} 
            </FlexView>
        </Popover>
    </React.Fragment>)
}

